import React, { useState, useEffect } from "react";
import clsx from "clsx";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import { SchoolCarrier } from "../../../models/financing-request/SchoolCarrier";
import FoodItem from "./FoodItem";
import TransportItem from "./TransportItem";
import StudentDataHeading from "./StudentDataHeading";
import {
  Grid,
  Button,
  Card,
  CardHeader,
  CardContent,
  Divider,
  makeStyles,
  createStyles,
  Theme,
  IconButton
} from "@material-ui/core";
import { Add as AddIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { PersonalPassenger } from "./FinancingRequestStudentDataStep";
import { TransportOptionType } from "../../../models/transport-option-type/TransportOptionType";
import PersonalPassengerTransportItem from "./PersonalPassengerTransportItem";
import TeachingAidItem from "./TeachingAidItem";
import { ProgramType } from "../../../models/financing-request/ProgramType";
import TransportOptionTypeApiClient from "../../../api/TransportOptionTypeApiClient";
import VehicleTypeApiClient from "../../../api/VehicleTypeApiClient";
import SelectItem from "../../../models/shared/SelectItem";
import { VehicleType } from "../../../models/vehicle-type/VehicleType";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrackerName from "../../../models/financing-request/student-data/FinancingRequestStudentDataTrackerName";
import { AuthorizedCarrier } from "../../../models/financing-request/AuthorizedCarrier";
import Currency from "../../../models/shared/Currency";
import AnnualAdministration from "../../../models/admin/annual-administration/AnnualAdministration";

interface Props {
  index: number;
  studentData: FinancingRequestStudentData;
  studentsData: FinancingRequestStudentData[];
  personalPassengers: PersonalPassenger[];
  schoolCarriers: SchoolCarrier[];
  authorizedCarriers: AuthorizedCarrier[];
  validationResult: ValidationResult;
  currency: Currency;
  annualPricing: AnnualAdministration;
  onTransportTypeChange: (studenId: number) => (e: any) => void;
  onTransportSelectChange: (studenId: number) => (e: any) => void;
  handleTransportSelectChangeMultipleStudents: (
    studenId: number
  ) => (e: any) => void;
  onTransportChange: (studenId: number) => (e: any) => void;
  addTransportOption: (studenId: number) => (e: any) => void;
  deleteTransportOption: (studenId: number) => (e: any) => void;
  addFoodOption: (studenId: number) => (e: any) => void;
  deleteFoodOption: (studenId: number) => (e: any) => void;
  onFoodChange: (studenId: number) => (e: any) => void;
  addTeachingAidOption: (studenId: number) => (e: any) => void;
  deleteTeachingAidOption: (studenId: number) => (e: any) => void;
  onTeachingAidChange: (studenId: number) => (e: any) => void;
}

function StudentDataItem({
  index,
  studentData,
  studentsData,
  personalPassengers,
  schoolCarriers,
  authorizedCarriers,
  validationResult,
  currency,
  annualPricing,
  onTransportSelectChange,
  handleTransportSelectChangeMultipleStudents,
  onTransportChange,
  onTransportTypeChange,
  addTransportOption,
  deleteTransportOption,
  addFoodOption,
  deleteFoodOption,
  onFoodChange,
  addTeachingAidOption,
  deleteTeachingAidOption,
  onTeachingAidChange
}: Props) {
  const classes = useStyles({});

  const [transportOptionTypeItems, setTransportOptionTypeItems] = useState<
    SelectItem<TransportOptionType>[]
  >(new Array<SelectItem<TransportOptionType>>());

  const [vehicleTypeItems, setVehicleTypeItems] = useState<
    SelectItem<VehicleType>[]
  >(new Array<SelectItem<VehicleType>>());

  useEffect(() => {
    async function getTransportOptionTypes() {
      const apiClient = new TransportOptionTypeApiClient();
      const transportOptionTypes = await apiClient.getTransportOptionTypes();

      setTransportOptionTypeItems([
        ...transportOptionTypeItems,
        ...transportOptionTypes
      ]);
    }

    async function getVehicleTypes() {
      const apiClient = new VehicleTypeApiClient();
      const vehicleTypes = await apiClient.getVehicleTypes();

      setVehicleTypeItems([...vehicleTypeItems, ...vehicleTypes]);
    }

    if (vehicleTypeItems == null || vehicleTypeItems.length == 0) {
      getVehicleTypes();
    }

    if (
      transportOptionTypeItems == null ||
      transportOptionTypeItems.length == 0
    ) {
      getTransportOptionTypes();
    }
  }, [studentData]);

  return (
    <ExpansionPanel>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        className={clsx(
          !validationResult.isArrayItemValid(
            TrackerName.StudentsData,
            index.toString()
          ) && classes.error
        )}
      >
        <StudentDataHeading studentData={studentData} />
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Grid container spacing={4}>
          {studentData.transportOption ? (
            (studentData.transportOption.transportOptionType != null &&
              studentData.transportOption.transportOptionType !==
                TransportOptionType.PersonalPassenger) ||
            studentData.transportOption.transportOptionType == null ? (
              <Card className={classes.card}>
                <CardHeader
                  titleTypographyProps={{ variant: "subtitle1" }}
                  title="Prijevoz"
                  action={
                    <IconButton
                      aria-label="delete"
                      onClick={deleteTransportOption(studentData.student.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                />
                <Divider />
                <CardContent>
                  {
                    <TransportItem
                      index={index}
                      schoolCarriers={schoolCarriers}
                      authorizedCarriers={authorizedCarriers}
                      studentData={studentData}
                      studentsData={studentsData}                      
                      personalPassengers={personalPassengers}
                      transportOptionTypeItems={transportOptionTypeItems}
                      currency={currency}
                      vehicleTypeItems={vehicleTypeItems}
                      validationResult={validationResult}
                      onTransportTypeChange={onTransportTypeChange}
                      onTransportSelectChange={onTransportSelectChange}
                      onTransportChange={onTransportChange}
                      handleTransportSelectChangeMultipleStudents={
                        handleTransportSelectChangeMultipleStudents
                      }
                    />
                  }
                </CardContent>
              </Card>
            ) : (
              <PersonalPassengerTransportItem
                transportOption={studentData.transportOption}
              />
            )
          ) : (
            <></>
          )}
          {studentData.foodOption &&
          studentData.student.programType == ProgramType.Elementary ? (
            <Card className={classes.card}>
              <CardHeader
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Prehrana"
                action={
                  <IconButton
                    aria-label="delete"
                    onClick={deleteFoodOption(studentData.student.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                }
              />
              <Divider />
              <CardContent>
                <FoodItem
                  foodOption={studentData.foodOption}
                  student={studentData.student}
                  onChange={onFoodChange(studentData.student.id)}
                />
              </CardContent>
            </Card>
          ) : (
            <></>
          )}
          {studentData.teachingAidOption ? (
            <Card className={classes.card}>
              <CardHeader
                titleTypographyProps={{ variant: "subtitle1" }}
                title="Posebna nastavna sredstva i pomagala"
                action={
                  <IconButton
                    aria-label="delete"
                    onClick={deleteTeachingAidOption(studentData.student.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                }
              />
              <Divider />
              <CardContent>
                {
                  <TeachingAidItem
                    studentData={studentData}
                    specialNeedType={studentData.student.specialNeedType}
                    currency={currency}
                    annualPricing={annualPricing}
                    onChange={onTeachingAidChange(studentData.student.id)}
                  />
                }
              </CardContent>
            </Card>
          ) : (
            <></>
          )}

          {!studentData.transportOption ? (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={addTransportOption(studentData.student.id)}
              >
                <AddIcon />
                Dodaj prijevoz
              </Button>
            </Grid>
          ) : (
            <></>
          )}
          {!studentData.foodOption &&
          studentData.student.programType == ProgramType.Elementary ? (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={addFoodOption(studentData.student.id)}
              >
                <AddIcon />
                Dodaj prehranu
              </Button>
            </Grid>
          ) : (
            <></>
          )}
          {!studentData.teachingAidOption ? (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={addTeachingAidOption(studentData.student.id)}
              >
                <AddIcon />
                Dodaj posebna nastavna sredstva i pomagala
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

function areEqual(prevProps: Props, nextProps: Props) {
  return (
    prevProps.studentData === nextProps.studentData &&
    prevProps.validationResult.getTrackerMessages(TrackerName.StudentsData) ===
      nextProps.validationResult.getTrackerMessages(TrackerName.StudentsData)
  );
}

export default React.memo(StudentDataItem, areEqual);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: "100%",
      marginTop: "10px"
    },
    error: {
      color: theme.palette.error.main
    }
  })
);
